import { UserRewardRepository } from "../../domain/repository/user_reward_repository";
import { UserRewardApiService } from "../data_source/user_reward_api_service";


export class UserRewardRepositoryImpl implements UserRewardRepository {
    private userRewardApiService: UserRewardApiService;

    constructor() {
        this.userRewardApiService = new UserRewardApiService();
    }

    async claimReward(id: string): Promise<void> {
        this.userRewardApiService.claimReward(id);
    }
}